export const Nationalities = axios => ({
  get () {
    return axios.get('/v1/nationalities')
  }
})
